export default __webpack_public_path__ + "static/media/image11.d130d819.jpg";